import I18n from 'I18n';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownWrapper = styled.div.withConfig({
  displayName: "EPDeviceSelectDropdown__DropdownWrapper",
  componentId: "sc-1aetyds-0"
})(["max-width:125px;button:first-of-type{border-bottom-left-radius:0;border-top-left-radius:0;}"]);
const EPDeviceSelectDropdown = ({
  buttonSize,
  devices,
  dropdownButtonClassName,
  onChange,
  selectedDevice
}) => {
  let isDeviceSelected = false;
  let buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "epDeviceSelectButton.custom"
  });
  if (devices.length === 0) return null;
  const devicesList = /*#__PURE__*/_jsx(UIList, {
    children: devices.reduce((acc, device) => {
      let deviceLabel;
      let deviceName;
      let devicePreviewWidth;
      if (typeof device === 'object') {
        const {
          label,
          name,
          previewWidth
        } = device;
        const {
          units,
          value
        } = previewWidth || {};
        deviceLabel = label;
        deviceName = name;
        devicePreviewWidth = value && units ? `${I18n.formatNumber(value)}${units}` : null;
      } else {
        deviceLabel = device;
        deviceName = device;
      }
      if (selectedDevice === deviceName) {
        isDeviceSelected = true;
        buttonText = /*#__PURE__*/_jsx("span", {
          children: deviceLabel
        });
      }
      acc.push( /*#__PURE__*/_jsxs(UIButton, {
        onClick: e => onChange(SyntheticEvent(deviceName, e)),
        children: [/*#__PURE__*/_jsx("div", {
          children: deviceLabel
        }), devicePreviewWidth && /*#__PURE__*/_jsx(Small, {
          className: "m-left-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "epDeviceSelectButton.editDeviceStyles",
            options: {
              devicePreviewWidth
            }
          })
        })]
      }, deviceName));
      return acc;
    }, [])
  });
  return /*#__PURE__*/_jsx(DropdownWrapper, {
    children: /*#__PURE__*/_jsx(UIDropdown, {
      "data-test-id": "device-select-dropdown"
      // @ts-expect-error Technically not supported but needed to match designs
      ,
      active: isDeviceSelected,
      buttonClassName: dropdownButtonClassName,
      buttonSize: buttonSize,
      buttonText: /*#__PURE__*/_jsx(UITruncateString, {
        children: buttonText
      }),
      placement: "bottom left",
      children: devicesList
    })
  });
};
export default EPDeviceSelectDropdown;